import { getSubscriptionPriceApi, PROFESSIONAL } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

function SubscriptionSection({pricingRef}) {
    const {makeApiCallFunc, userDetails} = useContext(Context);
    const [priceObj, setPriceObj] = useState({});
    useEffect(() => {
        makeApiCallFunc(getSubscriptionPriceApi,
            {
                isUserFunder: false
            },
            ({data}) => {
                const priceInDollars = (data?.price?.unit_amount || 0) / 100;
                setPriceObj({"price":priceInDollars.toFixed(2), "currency":data?.price?.currency });
                console.log(data)
            },
            (error) => {
                console.log(error)
            },
            null,
            true,
            true
        )
    }, [])
  return (
    <div className='pt-10 border border-1 p-2 lg:p-10 border-blue-800 rounded bg-blue-800 '
    ref={pricingRef}
    >
        <div className='text-sm lg:text-md  font-bold text-white'>For Attorneys</div>
        <div className='text-sm lg:text-4xl mt-10 text-white'>Become a Premium Attorney - Accelerate your growth</div>
        <div className='mt-2 text-sm lg:text-xl text-white'>Connect with Clients Quickly with Our Affordable Basic Plan.</div>
        <div className='flex  lg:flex-row flex-col mt-10 lg:mt-20'>
                       <div className='flex flex-col  flex-1 lg:mr-2'>
                <div className="flex p-4 bg-white w-full h-full flex flex-col shadow-md border border-blue-600 ring-1 ring-offset-1 ring-blue-600 rounded-md flex-col ">
                    <div className="font-bold text-xl mb-1 font-bold text-left text-blue-600 ">Basic Plan (Free)</div>
                    <div className='text-sm text-left  text-gray-600'>For Professionals</div>
                    <div className='flex items-end mt-4  '>
                        <span className='text-[34px] flex items-end '>
                            $0.00</span>
                        <span className='text-sm ml-1 mb-2   '>per month</span>
                    </div>
                    <Link to={
                        userDetails.role === PROFESSIONAL ? 
                         userDetails?.verified === false ? "/attorney/profile" : "/attorney/subscription"
                        
                        : "/signup/2"
                    }>
                        <div className=' rounded p-1 bg-blue-800 border-blue-800 border text-white  text-center  pt-2 pb-2 w-full mt-6'>Start Subscription -&gt;</div>
                    </Link>
                    <div className="flex flex-col rounded mt-4 items-start p-4 text-sm bg-blue-50">
                        <div class="   text-gray-800 text-md">
                        <ul class="list-disc pl-4 text-left space-y-3 text-[16px]">
                            <li className=''>
                            <strong>Limited Access to the Latest Cases</strong>  
                            </li>
                            
                            <li>
                            <strong>Streamlined Case Approvals</strong>  
                            </li>
                            <li>
                            <strong>Unlimited Case Requests</strong>  
                            </li>
                            <li>
                            <strong>Unlimited Leads</strong>  
                            </li>
                            <li>
                            <strong>Add Legal Assistants</strong>  
                            </li>
                            <li>
                            <strong>Limited Data Access</strong>  
                            </li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='flex flex-col flex-1'>
                <div className="flex p-4 bg-white flex w-full shadow-md border border-blue-600 ring-1 ring-offset-1 ring-blue-600 rounded-md flex-col ">
                <div className="font-bold text-xl mb-1 font-bold text-left text-blue-600 ">Premium Subscription</div>
                <div className='text-sm text-left  text-gray-600'>For Professionals</div>
                <div className='flex items-end mt-4'>
                    <span className='text-[34px] flex items-end '>
                        {priceObj.currency === "usd" && "$"}
                        {priceObj.price}</span>
                    <span className='text-sm ml-1 mb-2  '>per month</span>
                </div>
                
                    <Link to={ userDetails?.verified === false ? "/attorney/profile" : "/attorney/subscription"}>
                        <div className='rounded p-1 bg-blue-800 border-blue-800 border text-white  text-center  pt-2 pb-2 w-full mt-6'>Start Subscription -&gt;</div>
                    </Link>
                
                <div className="flex flex-col rounded mt-4 items-start p-4 text-sm bg-blue-50">
                    <div class="   text-gray-800 text-md">
                    <ul class="list-disc pl-4 text-left space-y-3 text-[16px]">
                        <li className=''>
                        <strong>Access to the Latest Cases</strong>  
                        </li>
                        <li>
                        <strong>Priority for Time-Sensitive Cases (SOS)</strong>  
                        </li>
                        <li>
                        <strong>Automatic Pre-Approval Listing</strong>  
                        </li>
                        <li>
                        <strong>Streamlined Case Approvals</strong>  
                        </li>
                        <li>
                        <strong>Unlimited Case Requests</strong>  
                        </li>
                        <li>
                        <strong>Unlimited Leads</strong>  
                        </li>
                        <li>
                        <strong>Premium Data Access</strong>  
                        </li>
                        <li>
                        <strong>Add Legal Assistants</strong>
                        </li>
                    </ul>
                    </div>
                </div>
                </div>
            
            </div>
        </div>
    </div>
  )
}

export default SubscriptionSection
